export default __webpack_public_path__ + "static/media/widecard.75821fe2.png";